module.exports = function() { throw new Error("define cannot be used indirect"); };



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-define.js
// module id = 114
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///(webpack)/buildin/amd-define.js